import React from 'react';
import { Calendar, Clock, AlertCircle, CheckCircle2, ArrowRight } from 'lucide-react';
import { Breadcrumbs } from '../components/ui/Breadcrumbs';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Badge } from '../components/ui/Badge';
interface CalendarEventPageProps {
  onNavigate: (page: string) => void;
}
export function CalendarEventPage({
  onNavigate
}: CalendarEventPageProps) {
  return <div className="w-full bg-slate-50 pb-24" data-id="element-22357">
      <div className="bg-white border-b border-slate-200 pt-8 pb-12" data-id="element-22358">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-22359">
          <Breadcrumbs items={[{
          label: 'Главная',
          onClick: () => onNavigate('home')
        }, {
          label: 'Астро-календарь',
          onClick: () => onNavigate('astro-daily')
        }, {
          label: 'Солнечное затмение в Весах'
        }]} className="mb-8" data-id="element-22360" />
          <div className="flex items-center gap-3 mb-6" data-id="element-22361">
            <Badge variant="warning" data-id="element-22362">Затмение</Badge>
            <span className="text-slate-500 flex items-center text-sm font-medium" data-id="element-22363">
              <Calendar className="w-4 h-4 mr-1" data-id="element-22364" /> 14 Октября 2024
            </span>
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6" data-id="element-22365">
            Солнечное затмение в Весах
          </h1>
          <p className="text-xl text-slate-600 leading-relaxed" data-id="element-22366">
            Мощное время кармических изменений в сфере партнерства, отношений и
            договоренностей.
          </p>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mt-12" data-id="element-22367">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-22368">
          <div className="md:col-span-2 prose prose-slate max-w-none" data-id="element-22369">
            <p data-id="element-22370">
              Солнечное затмение всегда совпадает с Новолунием, но его влияние в
              разы сильнее. Это время закладки новых циклов, которые будут
              разворачиваться в течение следующих 6-18 месяцев.
            </p>
            <p data-id="element-22371">
              Знак Весов акцентирует темы баланса, справедливости, брака и
              делового партнерства. В этот период могут происходить судьбоносные
              встречи или, наоборот, завершаться отношения, изжившие себя.
            </p>

            <h3 className="text-2xl font-bold text-slate-900 mt-10 mb-6" data-id="element-22372">
              Кому это особенно важно?
            </h3>
            <ul className="space-y-2 not-prose mb-10" data-id="element-22373">
              <li className="flex items-start text-slate-700" data-id="element-22374">
                <AlertCircle className="w-5 h-5 text-amber-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-22375" />
                <span data-id="element-22376">
                  Тем, у кого Солнце, Луна или Асцендент в знаках:{' '}
                  <strong data-id="element-22377">Весы, Овен, Рак, Козерог</strong>.
                </span>
              </li>
              <li className="flex items-start text-slate-700" data-id="element-22378">
                <AlertCircle className="w-5 h-5 text-amber-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-22379" />
                <span data-id="element-22380">
                  Тем, кто планирует свадьбу, развод или подписание важных
                  контрактов.
                </span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-slate-900 mt-10 mb-6" data-id="element-22381">
              Советы на период затмения
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 not-prose" data-id="element-22382">
              <Card padding="md" className="border-emerald-200 bg-emerald-50/30" data-id="element-22383">
                <h4 className="font-bold text-emerald-800 mb-3 flex items-center" data-id="element-22384">
                  <CheckCircle2 className="w-5 h-5 mr-2" data-id="element-22385" /> Благоприятно
                </h4>
                <ul className="text-sm text-emerald-900 space-y-2" data-id="element-22386">
                  <li data-id="element-22387">• Искать компромиссы</li>
                  <li data-id="element-22388">• Завершать старые конфликты</li>
                  <li data-id="element-22389">• Наводить порядок в документах</li>
                  <li data-id="element-22390">• Заниматься эстетикой и красотой</li>
                </ul>
              </Card>
              <Card padding="md" className="border-rose-200 bg-rose-50/30" data-id="element-22391">
                <h4 className="font-bold text-rose-800 mb-3 flex items-center" data-id="element-22392">
                  <AlertCircle className="w-5 h-5 mr-2" data-id="element-22393" /> Не рекомендуется
                </h4>
                <ul className="text-sm text-rose-900 space-y-2" data-id="element-22394">
                  <li data-id="element-22395">• Принимать импульсивные решения</li>
                  <li data-id="element-22396">• Рвать отношения "на эмоциях"</li>
                  <li data-id="element-22397">• Начинать судебные процессы</li>
                  <li data-id="element-22398">• Проводить плановые операции</li>
                </ul>
              </Card>
            </div>
          </div>

          <div className="md:col-span-1" data-id="element-22399">
            <div className="sticky top-28" data-id="element-22400">
              <Card padding="lg" className="bg-slate-900 text-white border-none" data-id="element-22401">
                <h3 className="text-xl font-bold mb-4" data-id="element-22402">
                  Как затмение повлияет лично на вас?
                </h3>
                <p className="text-slate-300 text-sm mb-6" data-id="element-22403">
                  Влияние затмения зависит от того, в какой дом вашей натальной
                  карты оно попадает. Узнайте это на личной консультации.
                </p>
                <Button variant="primary" fullWidth onClick={() => onNavigate('astrologers')} data-id="element-22404">
                  Выбрать астролога
                </Button>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </div>;
}